const PLACEHOLDER_USERNAMES = new Set([
  'your_bot_username_here',
  'your_production_bot',
  'your_bot_username',
]);

export function resolveTelegramBotUsername(): string | null {
  const raw = import.meta.env.VITE_TELEGRAM_BOT_USERNAME?.trim();
  if (!raw) {
    return null;
  }

  const username = raw.replace(/^@/, '');
  if (!username || PLACEHOLDER_USERNAMES.has(username)) {
    return null;
  }

  return username;
}
